<div class="search-multiselect" [class.search-multiselect--open]="helper.FORM" [class.search-multiselect--filled]="helper.selected?.length">

  <!-- field -->
  <div
    class="inner"
    (hidden)="helper.FORM = null"
    [ngbPopover]="popContent"
    #popContentRef="ngbPopover"
    placement="bottom-left bottom-right"
    popoverClass="popover--search-multiselect"
    [container]="'body'"
    [autoClose]="'outside'"
    (click)="openForm(popContentRef)">
    <!-- empty -->
    @if (!helper.selected?.length) {
      <span class="empty">{{placeholder}}</span>
    }
    <!-- filled -->
    @if (helper.selected?.length) {
      <span class="label">{{placeholder}}:</span>
      <!-- model -->
      <div class="d-flex align-items-center">
        <span class="value">{{helper.selected && helper.selected[0]?.title}}</span>
        @if (helper.selected.length > 1) {
          <span class="more">+{{helper.selected.length - 1}}</span>
        }
      </div>
    }
    <!-- icon -->
    <i class="im-icon im-icon-triangle-rounded-down"></i>
  </div>

  <!-- popover -->
  <ng-template #popContent>
    @if (helper.FORM) {
      <div class="popover--inner" style="min-width: 250px">
        <div class="popover-rows-wrapper">
          @if (withGroups) {
            @for (group of groupedOptions; track group) {
              <span class="label">{{ group.title }}</span>
              @for (option of group.options; track option) {
                <div class="popover-row" (click)="toggleSelect(option)">
                  <app-field-single-check-sm [model]="helper.FORM.species.indexOf(option.value) !== -1"></app-field-single-check-sm>
                  <div class="title">{{option.title}}</div>
                </div>
              }
            }
          } @else {
            @for (option of options; track option) {
              <div class="popover-row" (click)="toggleSelect(option)">
                <app-field-single-check-sm [model]="helper.FORM.species.indexOf(option.value) !== -1"></app-field-single-check-sm>
                <div class="title">{{option.title}}</div>
              </div>
            }
          }
        </div>
        @if (allowClear) {
          <div class="clear-wrap" (click)="clear()">
            <span class="clear">{{'misc_clear_selection' | translate}}</span>
          </div>
        }
      </div>
    }
  </ng-template>
</div>